import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Manino - Professional Cleaning & Moving Services',
  description = 'Professional cleaning and moving services in Uzbekistan. Quality service, affordable prices, experienced team. Contact us for residential and commercial cleaning.',
  keywords = 'cleaning services, moving services, professional cleaning, residential cleaning, commercial cleaning, Uzbekistan, Manino',
  image = '/assets/img/logo.png',
  url = window.location.href,
  type = 'website'
}) => {
  const siteTitle = 'Manino - At Your Service';
  const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Manino" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;